import React, { Children, useEffect, useState, useRef } from 'react'

import classes from "./IFTTTRuleLayout.module.css";
import arrowIcon from "../../../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/Site/__Page - Forward.svg";
import Pill_Widget from '../../../Widgets/Pill_Widget';
import Modal from '../../../../Modal/Modal';
import List from './List';
import AffectedSwitchesList from './AffectedSwitchesList';
import Button1 from '../../../Button/Button1';
import { deleteScheduleApi, setInputRuleApi, updateScheduleApi } from '../../../../../Api Methods/Api';
import { useDispatch, useSelector } from 'react-redux';
import ScheduledAction from './ScheduledAction';
import SelectOutputs from './SelectOutputs';
import { format } from 'date-fns';
import RuleCard from '../../Rules/RuleCard';
import { act } from 'react';
import { UseConvertScheduleTimezone } from '../../../../hooks/UseConvertScheduleTimezone';

const ScheduleContentLayout = ({ item, outputs, inputs, fetchAutomations }) => {

    const { id: scheduleID, action, pin: pins, time, days, active, reminder: isReminder, createdBy, dateCreated, timezone } = item;

    // convert the stored (creation-timezone) time/days to the viewer's current timezone for display only
    const { time: displayTime, days: displayDays } = UseConvertScheduleTimezone(time, days, timezone);

    const DateCreated = dateCreated != null ? dateCreated : ""
    const CreatedBy = createdBy != null ? createdBy?.fullName : "Unknown user"
    const client = useSelector(state => state.auth.client);
    const token = useSelector(state => state.auth.token);
    const DeviceUUID = useSelector(state => state.auth.DeviceUUID);

    const allPins = outputs.concat(inputs)

    const actions = []
    for (const pin of allPins){
        if (item.pin.includes(String(pin.Pin))){
            actions.push(item.action == "Arm" ? pin.pinStatusOff : pin.pinStatusOn)
        }
    }

    const title = isReminder ? "Smart reminder" : "Permanent schedule"
    const role = useSelector(state => state.auth.role);
    const showRemoveScheduleButton = true;
    const apiData = {
        token,
        client
    }

    //------------------------------- Modal Logic  ----------------------------------------------

    const ModalDialog = useRef();

    // call ref to clearStates method from child component ScheduledAction.
    const ClearStatesChildComponetRef = useRef();

    const HandleShowModal = () => {
        ModalDialog.current.open();
    }

    const HandleCloseModal = () => {
        ModalDialog.current.close();

        //reset states for scheduled Action
        if (ClearStatesChildComponetRef.current && ClearStatesChildComponetRef.current.HandleResetAllStates) {
            // Call the child method
            ClearStatesChildComponetRef.current.HandleResetAllStates();
        }

        //reset model screens
        HandelResetModal();
    }

    const [modalTitle, setModalTitle] = useState("Edit " + title)
    const [modalComponent, setModalComponent] = useState()
    //--------------------------------------------------------------------------------------------
    const [modalPageIndex, setModalPageIndex] = useState(null);



    // reset model when Escape key is pressed
    useEffect(() => {
        const handleKeyDown = (event) => {
            if (event.key === 'Escape') {
                // Handle the Escape key press here
                HandelResetModal();
                setModalPageIndex(null);
            }
        };

        // Add event listener when component mounts
        document.addEventListener('keydown', handleKeyDown);


        // Clean up event listener when component unmounts
        return () => {
            document.removeEventListener('keydown', handleKeyDown);
        };
    }, []);

    //constants for updating content on each modal page
    const [isFormValid, setIsFormValid] = useState(false);

    const [ListArray, setListArray] = useState(outputs)

    const HandelResetModal = () => {
        setModalPageIndex(null);
    }

    const body = {
        "id": scheduleID,
        "deviceUUID": DeviceUUID,
        "pin": pins, //   "pin": [ "5", "13", "19" ]
        "days": days, // [ "0", "1" ]
        "time": time, // "23:59"
        "active": active, //: 1,
        "action": action, // "Arm"
        "reminder": isReminder, //0 = schedule, 1 = Reminder
        "timezone": timezone // the timezone the schedule was originally created in
    }

    // re-render modal to show new modal componet. 
    useEffect(() => {
        switch (modalPageIndex) {
            case 1:
                setModalComponent(<ScheduledAction body={body} OutPutOptions={outputs} title={title} isReminder={isReminder} nextPage={setModalPageIndex} onSubmit={UpdateSchedule} DeleteSchedule={DeleteSchedule} showRemoveScheduleButton={showRemoveScheduleButton} />)
                HandleShowModal();
                break;
            case 3:
                //setModalComponent(<SelectOutputs body={body} setBody={setBody} listItems={OutPutOptions} modalPageIndex={modalPageIndex} nextPage={setModalPageIndex} showAutomation={isReminder} time={time} />)
                break;
        }

    }, [modalPageIndex])


    const dispatch = useDispatch();

    const DeleteSchedule = async () => {
        const response = await deleteScheduleApi(apiData, scheduleID, dispatch);
        if (response && response.success) {
            HandleCloseModal();
            fetchAutomations();
        }

    }

    const UpdateSchedule = async (body) => {
        const response = await updateScheduleApi(apiData, body, dispatch);
        if (response && response.success) {
            HandleCloseModal();
            fetchAutomations();
        }
    }
    const PinsPinNames = outputs?.filter(output => (pins?.includes(String(output.Pin)) || pins?.includes((output.Pin))));
    const reversePins = PinsPinNames.reverse()
    const pinNames = reversePins.map(item => item.pinName).join(', ');

    const sortedDays = () => {
        const Days = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"];
        const selectedDayNames = displayDays.map(dayNumber => Days[dayNumber]).join(',');
      
        if (displayDays.length === 7) {
          return "everyday";
        } else if (selectedDayNames === "Mon,Tue,Wed,Thu,Fri") {
          return "on weekdays";
        } else if (selectedDayNames === "Sat,Sun") {
          return "on weekends";
        } else {
          return "on " + selectedDayNames.split(',').join(', ');
        }
      };

    return (
        <>
            <Modal ref={ModalDialog} title={modalTitle} HandleShowModal={HandleShowModal} HandleCloseModal={HandleCloseModal} style={{ minWidth: "700px", minHeight: "420.5px" }} modalLayoutStyle={{ alignItems: "center" }}>
                {modalComponent}
            </Modal>

            <RuleCard
                header={`${title}`}
                onClick={() => setModalPageIndex(1)}
                meta={[isReminder ? `You will be reminded when ${pinNames} is ${actions} at ${displayTime} on ${sortedDays()}`
                    : `${pinNames} will ${action} at ${displayTime} ${sortedDays()}` ]}
                rightContent={
                    <>
                        <Pill_Widget height={{ height: "20px" }} boolean={active} PillColor_IfTrue={"var(--Active-color)"} PillColor_IfFalse={"var(--Inactive-color)"} text_IfTrue={"Active"} text_IfFalse={"Inactive"} className={classes.PillHeight} />
                    </>
                }
                footer={
                    createdBy && dateCreated
                      ? `Created by ${createdBy.fullName} on ${format(
                          new Date(dateCreated),
                          "MMM do, yyyy - HH:mm"
                        )}`
                      : null
                  }            />    
        </>
    )
}

export default ScheduleContentLayout;




